import React from "react";
import { SOLUTIONS_BLOCKS } from "./solutionsData";
import SolutionsVisual from "./SolutionsVisuals";

export default function SolutionsBlocks() {
  return (
    <div id="sol-blocks">
      {SOLUTIONS_BLOCKS.map((block) => (
        <section
          key={block.id}
          className={`sol-block${block.muted ? " sol-block--muted" : ""}${block.reverse ? " sol-block--reverse" : ""}`}
        >
          <div className="sol-block__inner">
            <div className="sol-block__copy">
              <div className="sol-block__meta">
                <span className={`sol-block__pill sol-block__pill--${block.pillClass}`}>
                  {block.pill}
                </span>
                <span className="sol-block__index">
                  {block.index} / 04
                </span>
              </div>
              <h2>{block.title}</h2>
              <p>{block.body}</p>
              <ul>
                {block.bullets.map((item) => (
                  <li key={item}>
                    <span aria-hidden="true">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="sol-block__visual">
              <SolutionsVisual type={block.visual} />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
